
import { ChangeDetectionStrategy , Component, OnInit , Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

type PaneType = 'left' | 'right';

@Component({
  selector: 'app-dialog-slide-panel',
  templateUrl: './dialog-slide-panel.component.html',
  styleUrls: ['./dialog-slide-panel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slide', [
      state('left', style({ transform: 'translateX(0)' })),
      state('right', style({ transform: 'translateX(-50%)' })),
      transition('* => *', animate(200))
    ])
  ]
})
export class DialogSlidePanelComponent implements OnInit {

  @Input() activePane: PaneType = 'left';

  constructor() { }

  ngOnInit(): void {
  }



}
